import { SeaReferenceTypesModel } from "entities/shared/seaCard.types";
import { ValueOf } from "shared/lib/typeCheck.lib";
import { t } from "shared/localization/localization";

export enum TabIdList {
  routes = "routes",
  vessels = "vessels",
  containers = "containers",
  exceptions = "exceptions",
  demurrage = "demurrage",
}

export const defaultActiveTabMap: Readonly<Record<Uppercase<ValueOf<typeof SeaReferenceTypesModel>>, TabIdList>> = {
  [SeaReferenceTypesModel.BK]: TabIdList.containers,
  [SeaReferenceTypesModel.BL]: TabIdList.containers,
  [SeaReferenceTypesModel.CT]: TabIdList.routes,
} as const;

export const eventDescriptionPlaceholder = t("Undefined Event");
